import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routing from "./router";
import "bootstrap/dist/css/bootstrap.css";
import "../src/style/style.css";
import "../src/style/responsive.css";

const App = () => {
  return (
    <BrowserRouter>
      <Routing />
    </BrowserRouter>
    // <BrowserRouter basename="/customer/">
    //   <Routing />
    // </BrowserRouter>
  );
};

export default App;
